<template lang="html">
  <div class="">
    <v-window
      :value="window"
      touchless
      color="transparent"
    >
      <v-window-item key="0">
        <div v-if="canceledAppointments.length > 0">
          <v-card-title>Cancelled appointments to refund</v-card-title>
          <v-list
            two-line
            class="pa-0"
          >
            <div
              v-for="(appointment, i) in canceledAppointments"
              :key="appointment.id"
            >
              <v-list-item
                :to="`/consulting/${appointment.id}`"
                @click="active = false"
              >
                <v-list-item-avatar
                  :color="appointment.client.color"
                  class="white--text"
                >
                  {{ appointment.client.initials }}
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ appointment.client.name }}</v-list-item-title>
                  <v-list-item-subtitle
                    class="captionxx"
                  >
                    {{ appointment.serviceName }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-layout ma-0>
                    <v-chip
                      small
                      :color="_appointmentStatus(appointment.status).color"
                      class="ma-1"
                    >
                      <v-icon left>
                        event
                      </v-icon>
                      {{ _appointmentStatus(appointment.status).text }}
                    </v-chip>
                    <v-chip
                      small
                      :color="_paymentStatus(appointment.paymentStatus).color"
                      class="ma-1"
                    >
                      <v-icon left>
                        paid
                      </v-icon>
                      {{ _paymentStatus(appointment.paymentStatus).text }}
                    </v-chip>
                  </v-layout>
                </v-list-item-action>
                <v-list-item-action>
                  <v-list-item-subtitle
                    class="captionxx"
                  >
                    {{ _formatDateTime(appointment.start) }}
                  </v-list-item-subtitle>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                v-if="i + 1 < canceledAppointments.length"
                inset
              />
            </div>
          </v-list>
          <v-divider />
        </div>
        <Calendar />
      </v-window-item>

      <v-window-item key="1">
        <Appointment />
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import helpers from "@/mixins/helpers";
import durations from "@/mixins/durations";
import binder from "@/mixins/binder";
import seen from "@/mixins/seen";
import mixins from "./components/mixins";
import Calendar from "./components/Calendar.vue";
import Appointment from "./components/Appointment.vue";
import { db } from '@/plugins/firebase'

export default {
  components: {
    Calendar,
    Appointment,
  },
  mixins: [ mixins, helpers, durations, binder, seen ],
  data() {
    return {
      canceledAppointments: []
    }
  },
  computed: {
    ...mapGetters(["_loader", "_badgeTotals", "_user"]),
    window() {
      return this.$route.params.sub ? 1 : 0;
    },

  },
  watch: {
    _badgeTotals() {
      if (!this.$route.params.sub) this._seenUpdate("consulting");
    },
  },
  beforeMount() {
    this._seenWatch("consulting", !this.$route.params.sub);
    this.$store.commit("set_appBarTitle", {
      title: "Consulting",
      icon: "event",
    });
    const callback = (data) => this.canceledAppointments = this._mutateAppointments(data)
    this.$bindDb(
      'canceledAppointments', 
      db.collection('services/consulting/appointments')
      .where('status', '==', 'canceled')
      .where('paymentStatus', '==', 'paid'),
      { callback }
      )
  },
  mounted() {
    this._seenUpdate("consulting");
  },
  methods: {
  },
};
</script>
<style lang="css" scoped>
</style>
